import React, { FC } from 'react';

import { SlotStyled } from './Slot.Styles';

interface ISlotProps {
  className?: string;
  extra?: string;
  label: string;
  value: string;
}

const Slot: FC<ISlotProps> = props => {
  const { label, value, extra, className } = props;

  return (
    <SlotStyled className={className ? `slot ${className}` : 'slot'}>
      <div className="slot-label">{label}</div>

      <div className="slot-value">
        {value} {extra && <span className="slot-extra">{extra}</span>}
      </div>
    </SlotStyled>
  );
};

export default Slot;
